import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export const useMutationSendAchVerificationEmail = ({
  api,
}: {
  api: ApiType;
}) => {
  return useMutation({
    mutationFn: (
      payload: Parameters<ApiType["memberApi"]["sendAchVerificationEmail"]>[0],
    ) => api.memberApi.sendAchVerificationEmail(payload),
  });
};
